var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-loading",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"loading-circle spin-round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }